(function(){
  // =======================
  // ====== CONFIG =========
  // =======================

  // 1) Google Apps Script Web App URL (termina en /exec)
  //    Pega aquí tu URL real del despliegue del Web App:
  const SHEETS_WEBAPP_URL = "https://script.google.com/macros/s/AKfycbyrW8ESEBh_pWu9gBVu_3J4RkemGko7TF48oGVo9XdZJ9BTd_rcZKSg4h48RH6qwBUrIw/exec";

  // 2) PayPal (lo que ya tenías)
  const PAYPAL_ONCE_BASE = "https://www.paypal.com/donate/?hosted_button_id=6HJAY48H5JSYU";
  const PAYPAL_ME_PREFIX = ""; // ej "https://www.paypal.me/TUUSUARIO" si quieres fallback
  const MONTHLY_PLANS = {
    50:  "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-66A86983JC3880512NDGE3LQ",
    100:  "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-26522506VR513850PNDGE4AA",
    150: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-58546083WP391315BNDGE5YQ",
    250: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-0R096917TS3475018NDGE6TA",
    500: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-35W93412U0746822NNDGFDHA",
    1000:"https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-5E9627332S377140SNDGFD7I"
  };

  // Comisión (si usas “cubrir comisión”)
  const FEES_PCT = 0.039; // 3.9%
  const FEES_FIXED = 4;   // $4 MXN

  // =======================
  // ===== UTILIDADES ======
  // =======================
  const wrap = document.getElementById('donateWizard');
  if (!wrap) return; // si no existe, salimos
  const $  = (sel, root=wrap)=>root.querySelector(sel);
  const $$ = (sel, root=wrap)=>Array.from(root.querySelectorAll(sel));
  const fmt = v => '$' + Number(v).toLocaleString('es-MX') + ' MXN';

  // Estado
  let mode   = 'once';   // 'once' | 'monthly'
  let amount = 20;       // por defecto
  let custom = 0;        // importe personalizado (solo 'once')
  let cover  = false;    // cubrir comisión

  // =======================
  // === Cálculos/Resumen ===
  // =======================
  function calcTotals(){
    let base = mode === 'once' ? (custom > 0 ? custom : amount) : amount;
    base = Math.max(1, Number(base||0));
    const fee   = cover ? Math.round((base * FEES_PCT + FEES_FIXED) * 100) / 100 : 0;
    const total = base + fee;
    return { base, fee, total };
  }

  function updateSummary(){
    const { base, fee, total } = calcTotals();
    const sumAmount = $('#dwSumAmount');
    const sumFreq   = $('#dwSumFreq');
    const sumFeeRow = $('#dwSumFeeRow');
    const sumFee    = $('#dwSumFee');
    const sumTotal  = $('#dwSumTotal');

    if (sumAmount) sumAmount.textContent = fmt(base);
    if (sumFreq)   sumFreq.textContent   = (mode === 'once' ? 'Una sola vez' : 'Mensual');
    if (sumFeeRow) sumFeeRow.hidden      = !(cover && fee > 0);
    if (sumFee)    sumFee.textContent    = fmt(fee);
    if (sumTotal)  sumTotal.textContent  = fmt(total);
  }

  function showStep(n){
    $$('.dw-step').forEach(card=>{
      const is = (Number(card.dataset.step) === n);
      card.hidden = !is;
      card.classList.toggle('is-active', is);
    });
    updateSummary();
  }

  // =======================
  // ===== Datos (lead) ====
  // =======================
  function getLead(){
    const form = $('#dwForm');
    const fd = new FormData(form);
    return {
      first_name: (fd.get('first_name') || '').trim(),
      last_name:  (fd.get('last_name')  || '').trim(),
      email:      (fd.get('email')      || '').trim(),
      phone:      (fd.get('phone')      || '').trim(),
      invoice:    (fd.get('invoice')    || '').trim(), // "si" | "no"
      // Honeypot opcional:
      website:    (fd.get('website')    || '').trim()
    };
  }

  async function saveLeadToWebhook(lead, meta){
    // Honeypot: si viene llenado, no enviamos
    if (lead.website) return;

    if (!SHEETS_WEBAPP_URL || SHEETS_WEBAPP_URL.indexOf('/exec') === -1) {
      console.warn('SHEETS_WEBAPP_URL no configurada o inválida.');
      return;
    }

    try {
      await fetch(SHEETS_WEBAPP_URL, {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          first_name: lead.first_name,
          last_name:  lead.last_name,
          email:      lead.email,
          phone:      lead.phone,
          invoice:    lead.invoice,
          frequency:  meta.frequency,
          amount:     meta.amount,
          total:      meta.total,
          cover:      meta.cover,
          page:       window.location.pathname,
          source:     'donate-wizard',
          timestamp:  new Date().toISOString()
        })
      });
    } catch (err) {
      console.warn('No se pudo enviar al Webhook (Sheets):', err);
    }
  }

  // =======================
  // ====== Listeners ======
  // =======================

  // Tabs frecuencia
  $$('.dw-tab').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      $$('.dw-tab').forEach(x=>x.classList.remove('is-active'));
      btn.classList.add('is-active');
      mode = btn.dataset.mode;
      const customWrap = $('.dw-custom');
      if (customWrap) customWrap.style.display = (mode === 'once') ? 'block' : 'none';
      updateSummary();
    });
  });

  // Montos
  $$('.dw-amt').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      $$('.dw-amt').forEach(x=>x.classList.remove('is-active'));
      btn.classList.add('is-active');
      amount = Number(btn.dataset.value);
      updateSummary();
    });
  });

  // Importe personalizado
  const customInput = $('#dwCustom');
  if (customInput) {
    customInput.addEventListener('input', ()=>{
      custom = Number(customInput.value || 0);
      updateSummary();
    });
  }

  // Cubrir comisión
  const coverInput = $('#dwCoverFee');
  if (coverInput) {
    coverInput.addEventListener('change', ()=>{
      cover = coverInput.checked;
      updateSummary();
    });
  }

  // Botones "Siguiente"
  $$('.dw-next').forEach(btn=>{
    btn.addEventListener('click', async ()=>{
      const stepEl = btn.closest('.dw-step');
      const current = Number(stepEl.dataset.step);

      if (current === 2) {
        // Validar formulario antes de pasar al 3
        const form = $('#dwForm');
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        // Recolectar y enviar lead (no bloquea el avance si falla)
        const lead = getLead();
        const totals = calcTotals();
        const meta = {
          amount: totals.base,
          total:  totals.total.toFixed(2),
          frequency: (mode === 'once' ? 'Una sola vez' : 'Mensual'),
          cover: cover ? 'Sí' : 'No'
        };

        // Enviar a Sheets, pero si falla igual avanzamos
        try { await saveLeadToWebhook(lead, meta); } catch(e) {}
      }

      showStep(current + 1);

      // Toast de confirmación cuando entramos al paso 3
      if (current === 2) {
        showToast('Datos guardados. ¡Gracias!');
      }
    });
  });

  // Botones "Atrás"
  $$('.dw-back').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const stepEl = btn.closest('.dw-step');
      const current = Number(stepEl.dataset.step);
      showStep(current - 1);
    });
  });

  // Botón pagar con PayPal (paso 3)
  const payBtn = $('#dwPay');
  if (payBtn) {
    payBtn.addEventListener('click', ()=>{
      const { total } = calcTotals();
      const value = total.toFixed(2);

      if (mode === 'once') {
        if (PAYPAL_ME_PREFIX) {
          window.location.href = `${PAYPAL_ME_PREFIX}/${value}MXN`;
          return;
        }
        const sep = PAYPAL_ONCE_BASE.includes('?') ? '&' : '?';
        const url = `${PAYPAL_ONCE_BASE}${sep}amount=${encodeURIComponent(value)}&currency_code=MXN`;
        window.location.href = url;
      } else {
        const planUrl = MONTHLY_PLANS[amount];
        if (!planUrl) { alert('Elige un monto mensual disponible.'); return; }
        window.location.href = planUrl;
      }
    });
  }

  // Mini toast
  function showToast(msg){
    let t = document.getElementById('dwToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'dwToast';
      Object.assign(t.style, {
        position:'fixed', left:'50%', bottom:'24px', transform:'translateX(-50%)',
        background:'#0ea5e9', color:'#fff', padding:'10px 14px', borderRadius:'10px',
        boxShadow:'0 8px 24px rgba(0,0,0,.25)', zIndex:'9999', fontWeight:'600'
      });
      document.body.appendChild(t);
    }
    t.textContent = msg || 'Hecho';
    t.style.opacity = '0';
    t.style.transition = 'opacity .2s ease';
    requestAnimationFrame(()=>{
      t.style.opacity = '1';
      setTimeout(()=>{ t.style.opacity = '0'; }, 1600);
    });
  }

  // Init
  showStep(1);
})();






